import { ReactNode } from 'react'

import { Icon } from '~/src/components/generic/PhosphorIcons/index'

import { Color } from '~/src/components/shared/Notification/types'
import { ExceptionTypename } from '~/src/components/shared/features/hooks/types'

import colors from '~/config/colorsScheme'

import { NotificationType, RiskTier } from '~/__generated_types__/globalTypes'

export const NotificationDisplayTier = {
  RISK: 'AT RISK',
  CRITICAL: 'CRITICAL',
  RESOLVED: 'RESOLVED',
}

export const NotificationDisplayViolation: Partial<Record<NotificationType, string>> = {
  HOS_VIOLATION: 'HoS violation',
  DETENTION: 'Two-hour dwell',
  LOAD_NOT_STARTED: 'Load not started',
  LOAD_AUDIT_DUE: 'Load audit due',
  LATE_APPOINTMENT: 'Late appointment',
  OSD_OVERAGE: 'Freight overage',
  OSD_SHORTAGE: 'Freight shortage',
  OSD_DAMAGED: 'Freight damaged',
  TENDER_WITHDRAWN: 'Tender withdrawn',
  LOAD_MATCHING_MISSING_EMPTY: 'Load matching: empty load not found',
  STOP_ATTEMPTED: 'Attempted stop',
  STOP_SKIPPED: 'Skipped stop',
}

export const ViolationDisplayText: Partial<
  Record<NotificationType | ExceptionTypename, string>
> = {
  ...NotificationDisplayViolation,
  LateArrivalException: 'Late arrival',
  AttemptedStopException: 'Attempted stop',
  SkippedStopException: 'Skipped stop',
}

export const colorsMapping: { [key: string]: Color } = {
  CRITICAL: 'red',
  RISK: 'yellow',
}

export const NOTIFICATION_COLOR_CLASS_NAME = {
  red: 'bg-red-50 rounded-sm w-fit px-0.5',
  yellow: 'bg-yellow-50 rounded-sm w-fit px-0.5',
}

export const iconMap: { [key in RiskTier]: ReactNode } = {
  [RiskTier.Risk]: <Icon color={colors.yellow[600]} name="WarningIcon" size="20" />,
  [RiskTier.Resolved]: (
    <Icon color={colors.green[700]} name="CheckCircleIcon" size="20" />
  ),
  [RiskTier.Critical]: (
    <Icon color={colors.red[600]} name="WarningCircleIcon" size="20" />
  ),
}
